import EventEmitter from "./services/event-emitter";

export default class Model extends EventEmitter {
  constructor() {
    super();
  }
}
